/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseAiAgentContextReadiness } from '../../models/api-response-ai-agent-context-readiness';

export interface GetAgentContextReadiness$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function getAgentContextReadiness(http: HttpClient, rootUrl: string, params: GetAgentContextReadiness$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAiAgentContextReadiness>> {
  const rb = new RequestBuilder(rootUrl, getAgentContextReadiness.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseAiAgentContextReadiness>;
    })
  );
}

getAgentContextReadiness.PATH = '/api/ai-assistant/agent/context-readiness';
